import { TASK_STATUS, type TaskStatus } from './domain.js'

export type TransitionActor = 'MANAGER' | 'ASSIGNEE'

export interface TransitionRule {
  from: TaskStatus
  to: TaskStatus
  actors: readonly TransitionActor[]
}

export const TASK_TRANSITIONS: readonly TransitionRule[] = [
  { from: TASK_STATUS.ASSIGNED, to: TASK_STATUS.IN_PROGRESS, actors: ['ASSIGNEE'] },
  { from: TASK_STATUS.ASSIGNED, to: TASK_STATUS.SUBMITTED, actors: ['ASSIGNEE'] },
  { from: TASK_STATUS.ASSIGNED, to: TASK_STATUS.BLOCKED, actors: ['ASSIGNEE'] },
  { from: TASK_STATUS.IN_PROGRESS, to: TASK_STATUS.SUBMITTED, actors: ['ASSIGNEE'] },
  { from: TASK_STATUS.IN_PROGRESS, to: TASK_STATUS.BLOCKED, actors: ['ASSIGNEE'] },
  { from: TASK_STATUS.RETURNED, to: TASK_STATUS.SUBMITTED, actors: ['ASSIGNEE'] },
  { from: TASK_STATUS.RETURNED, to: TASK_STATUS.BLOCKED, actors: ['ASSIGNEE'] },
  {
    from: TASK_STATUS.BLOCKED,
    to: TASK_STATUS.ASSIGNED,
    actors: ['ASSIGNEE', 'MANAGER'],
  },
  {
    from: TASK_STATUS.BLOCKED,
    to: TASK_STATUS.IN_PROGRESS,
    actors: ['ASSIGNEE', 'MANAGER'],
  },
  {
    from: TASK_STATUS.BLOCKED,
    to: TASK_STATUS.RETURNED,
    actors: ['ASSIGNEE', 'MANAGER'],
  },
  { from: TASK_STATUS.SUBMITTED, to: TASK_STATUS.APPROVED, actors: ['MANAGER'] },
  { from: TASK_STATUS.SUBMITTED, to: TASK_STATUS.RETURNED, actors: ['MANAGER'] },
]

export function canTransition(from: TaskStatus, to: TaskStatus, actor: TransitionActor): boolean {
  return TASK_TRANSITIONS.some(
    (rule) => rule.from === from && rule.to === to && rule.actors.includes(actor),
  )
}

export function allowedTransitions(
  from: TaskStatus,
  actor?: TransitionActor,
): readonly TaskStatus[] {
  return TASK_TRANSITIONS.filter(
    (rule) => rule.from === from && (actor === undefined || rule.actors.includes(actor)),
  ).map((rule) => rule.to)
}
